module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/14-0315f3358ff0ffc54148c99c01dd63c3.jpg";